// src/components/profile/ProfileSectionPreview.jsx - New component
import React from 'react';
import { ProfileTemplate } from '../templates/ProfileTemplate';

export const ProfileSectionPreview = ({ 
  bookId, 
  book, 
  sections, 
  highlightSection 
}) => {
  // Create a preview version of the book data
  const previewBookData = {
    ...book,
    profileSections: sections
  };

  // If highlighting a specific section, we could add special styling
  const previewStyling = {
    ...book?.styling,
    // Add any preview-specific styling here
  };

  return (
    <div className="profile-preview-container">
      {highlightSection && (
        <div className="bg-yellow-50 border border-yellow-200 p-3 mb-4 rounded-lg">
          <p className="text-sm text-yellow-800">
            <strong>Previewing:</strong> {highlightSection.title} ({highlightSection.type})
          </p>
        </div>
      )}
      
      <ProfileTemplate
        bookId={bookId}
        book={previewBookData}
        messages={[]}
        bookData={previewBookData}
        styling={previewStyling}
        profileSettings={book?.profileSettings || {}}
        customCSS={book?.customCSS || ''}
      />
      
      {highlightSection && (
        <style jsx>{`
          .profile-template .section-wrapper:has([data-section-type="${highlightSection.type}"]) {
            outline: 3px solid #fbbf24;
            outline-offset: 4px;
            border-radius: 12px;
          }
        `}</style>
      )}
    </div>
  );
};